import React, { useEffect, useState } from "react";
import { useCallProviderStore, useUserInfo } from "../store";
import { getCurrentUserRole } from "modules/utilities/utility";
import _ from "lodash";
import UserCallProviderModal from "./UserCallProviderModal";
import { Card } from "antd";
import UsersCallProvider from "./UsersCallProvider";
import CallProviders from "./CallProviders";
import CallProviderModal from "./CallProviderModal";

function CallProviderManagement() {
  const {
    fetchCallProvider,
    isUserCallProviderLoading,
    isCallProviderLoading,
    callProvidersResponse,
    userCallProvidersResponse,
    fetchUserCallProvider,
    updateUserCallProviderHandler,
    createUserCallProvider,
    updateCallProviderHandler,
    createCallProviderHandler,
  } = useCallProviderStore();
  const [type, setType] = useState("edit");
  const [callProviderType, setCallProviderType] = useState("edit");
  useEffect(() => {
    fetchCallProvider();
    fetchUserCallProvider();
  }, []);

  const { fetchUserData, userData } = useUserInfo();

  useEffect(() => {
    if (type === "new" && _.isEmpty(userData)) {
      fetchUserData(getCurrentUserRole());
    }
  }, [type]);

  const [filter, setFilter] = useState({
    page: 1,
    limit: 10,
  });

  const [user, setUser] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedCallProvider, setSelectedCallProvider] = useState(null);
  const [isCallProviderModalOpen, setIsCallProviderModalOpen] = useState(false);

  const [searchLoading, setSearchLoading] = useState(false);
  function queryString(filter = {}) {
    const params = new URLSearchParams(filter);

    for (const [filterKey, filterValue] of Object.entries(filter)) {
      if (Array.isArray(filterValue)) {
        filterValue.forEach((item) => params.append(`${filterKey}[]`, item));
        params.delete(filterKey);
      } else {
        params.set(filterKey, filterValue);
      }
    }
    return params.toString();
  }
  async function handleUserCallProviderFilter({ key, value }) {
    const updatedFilter = { ...filter, [key]: value };
    if (_.isEmpty(value)) {
      _.unset(updatedFilter, key);
    }
    setFilter(updatedFilter);
    await fetchUserCallProvider(queryString(updatedFilter));
    setSearchLoading(false);
  }

  async function handleUpdateUserCallProviderDetails({
    key,
    value,
    userCallProviderId,
  }) {
    await updateUserCallProviderHandler(userCallProviderId, { [key]: value });
    await fetchUserCallProvider(queryString(filter));
  }

  const handleToggleModal = ({ user = {}, type } = {}) => {
    setType(type);
    setUser(user);
    setIsModalOpen(!isModalOpen);
  };

  const handleToggleCallProvider = ({ provider = null, type } = {}) => {
    setCallProviderType(type);
    setSelectedCallProvider(provider);
    setIsCallProviderModalOpen(!isCallProviderModalOpen);
  };
  async function handleUserCallProviderSubmitForm(userCallProviderId, values) {
    if (type === "new") {
      await createUserCallProvider(values);
    } else {
      await updateUserCallProviderHandler(userCallProviderId, values);
    }
    handleToggleModal({});
    await fetchUserCallProvider(queryString(filter));
  }

  async function handleCallProviderSubmitForm(providerId, values) {
    let config = _.get(values, "config");

    try {
      config = typeof config === "string" ? JSON.parse(config) : config;
    } catch {
      config = null;
    }

    const updatedConfig =
      _.isNil(config) ||
      ["null", "", "{}"].includes(config) ||
      (_.isObject(config) && _.isEmpty(config))
        ? null
        : config;

    const data = {
      ..._.omit(values, "config"),
      ...(updatedConfig !== null && { config: updatedConfig }),
    };
    if (callProviderType === "new") {
      await createCallProviderHandler(data);
    } else {
      await updateCallProviderHandler(providerId, data);
    }
    handleToggleCallProvider({});
    await fetchCallProvider();
  }

  async function handleUpdateCallProviderDetails({ key, value, providerId }) {
    await updateCallProviderHandler(providerId, { [key]: value });
    await fetchCallProvider();
  }
  const tabList = [
    {
      key: "tab1",
      tab: "Users Call Provider",
    },
    {
      key: "tab2",
      tab: "Call Providers",
    },
  ];
  const contentList = {
    tab1: (
      <UsersCallProvider
        searchLoading={searchLoading}
        setSearchLoading={setSearchLoading}
        callProvidersResponse={callProvidersResponse}
        userCallProvidersResponse={userCallProvidersResponse}
        handleUserCallProviderFilter={handleUserCallProviderFilter}
        handleUpdateUserCallProviderDetails={
          handleUpdateUserCallProviderDetails
        }
        handleToggleModal={handleToggleModal}
        isUserCallProviderLoading={isUserCallProviderLoading}
      />
    ),
    tab2: (
      <CallProviders
        callProvidersResponse={callProvidersResponse}
        handleUpdateCallProviderDetails={handleUpdateCallProviderDetails}
        handleToggleCallProvider={handleToggleCallProvider}
        isCallProviderLoading={isCallProviderLoading}
      />
    ),
  };

  const [activeTabKey, setActiveTabKey] = useState("tab1");
  const onTabChange = (key) => {
    setActiveTabKey(key);
  };

  return (
    <>
      <Card
        style={{
          width: "100%",
        }}
        title="Call Provider Management"
        tabList={tabList}
        tabProps={{ size: "middle" }}
        activeTabKey={activeTabKey}
        onTabChange={onTabChange}
      >
        {contentList[activeTabKey]}
      </Card>

      {isModalOpen ? (
        <UserCallProviderModal
          isModalOpen={isModalOpen}
          user={user}
          type={type}
          handleToggleModal={handleToggleModal}
          handleSubmitForm={handleUserCallProviderSubmitForm}
          usersList={userData}
          providersList={callProvidersResponse}
        />
      ) : null}
      {isCallProviderModalOpen ? (
        <CallProviderModal
          selectedCallProvider={selectedCallProvider}
          isCallProviderModalOpen={isCallProviderModalOpen}
          handleToggleCallProvider={handleToggleCallProvider}
          handleSubmitForm={handleCallProviderSubmitForm}
        />
      ) : null}
    </>
  );
}

export default CallProviderManagement;
